import Vue from 'vue';
import { BfModal, BfButton, BfDialog } from "components/Butterfly";
const ModalConfirmPrompt = Vue.extend({
    components: { BfDialog, BfModal, BfButton },
    props: {
        visible: { type: Boolean, required: true },
        confirmText: { type: String, required: false, default: 'Confirm' },
        cancelText: { type: String, required: false, default: 'Cancel' },
        title: { type: String, required: false, default: '' },
    },
    methods: {
        close() {
            this.$emit('close');
        },
        confirm() {
            this.$emit('confirm');
        }
    }
});
export default ModalConfirmPrompt;
